import HttpFactory from "~/repository/factory";
import { createPublicRequestConfig } from "~/repository/authSession";
import type { RecaptchaInput } from "~/types/auth";
import type { PublicSchoolForm, SchoolFormAnswers } from "~/types/schoolForms";

const root = "/api/forms/public/";
export default class PublicSchoolFormsModule extends HttpFactory {
  getForm(token: string) {
    return this.get<PublicSchoolForm>(
      `${root}${encodeURIComponent(token)}/`,
      {},
      createPublicRequestConfig(),
    );
  }

  submit(
    token: string,
    input: {
      context: string;
      client_submission_id: string;
      answers: SchoolFormAnswers;
      recaptcha: RecaptchaInput;
      website: string;
    },
  ) {
    return this.post<{ detail: string }>(
      `${root}${encodeURIComponent(token)}/submissions/`,
      input,
      createPublicRequestConfig(),
    );
  }
}
